<template>
  <div class="common-bg">
    <div class="tool-drawer-header">
      <a @click="clickBack">
        <a-icon type="left" />
      </a>
      <div class="title">{{ $t('edit.hpInfo.imageText') }}</div>
    </div>

    <div class="tool-drawer-content">
      <IconSelect
        :currentIcon="picObj.icon_url"
        @onSelectIcon="onSelectIcon"
        :type="1"
      ></IconSelect>

      <div class="tit-box">
        <div>
          <div style="margin-bottom: 5px">
            <span>{{ $t('edit.hpInfo.IconScale') }}</span>
          </div>
          <a-row class="titleScaleBg">
            <a-col :span="24">
              <a-slider :min="1" :max="300" :step="1" v-model="currScale" />
            </a-col>
          </a-row>
        </div>
        <div class="tit-desc">
          <span>{{ $t('edit.title') }}</span>
          <a-checkbox
            :checked="picObj.is_show_title === 1"
            @change="isShowTitle"
          >
            {{ $t('edit.hpInfo.showTitle') }}
          </a-checkbox>
        </div>
        <div style="background-color: #212121">
          <div class="tit-desc-px">
            <a-input
              :placeholder="$t('edit.hpInfo.inputTitle')"
              v-model="currTitle"
            />
            <div class="tit-px">
              <a-input
                class="title-input"
                :placeholder="currFontSize"
                v-model="currFontSize"
              />
              <span style="padding-left: 2px">px</span>
            </div>
          </div>
          <div class="tit_position_bg">
            <a-button
              class="tit_position_btn"
              type="primary"
              v-for="(item, index) in btnPosition"
              :key="index"
              @click="onClickBtn(item, index)"
              :class="{ tit_active: index == currentPosition }"
            >
              {{ item.name }}
            </a-button>
          </div>
          <div class="tit_sliderbar_bg">
            <a-row>
              <a-col :span="6" style="padding: 5px">
                {{ $t('edit.hpInfo.title_x') }}
              </a-col>
              <a-col :span="18">
                <a-slider :min="-100" :max="100" :step="1" v-model="curr_x" />
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="6" style="padding: 5px">
                {{ $t('edit.hpInfo.title_y') }}
              </a-col>
              <a-col :span="18">
                <a-slider :min="-100" :max="100" :step="1" v-model="curr_y" />
              </a-col>
            </a-row>
          </div>
        </div>
        <!-- <a-row style="margin-top: 10px">
                    <a-col :span="18">
                      <a-slider :min="-300" :max="300" :step="1" v-model="picObj.tit_position_x" />
                    </a-col>
                    <a-col :span="18">
                      <a-slider :min="-300" :max="300" :step="1" v-model="picObj.tit_position_y" />
                    </a-col>
                </a-row>
                <a-input :placeholder="$t('edit.hpInfo.inputTitle')" v-model="picObj.tit_position_align" />
                <a-input :placeholder="$t('edit.hpInfo.inputTitle')" v-model="picObj.tit_position_edge" /> -->
      </div>

      <div class="tit-box">
        <span class="pictext-content">
          {{ $t('table.common.thead.content') }}
        </span>
        <a-button type="primary" @click="editVisible = true">
          {{ $t('actionTitles.edit') }}{{ $t('table.common.thead.content') }}
        </a-button>
        <!--                <editor :value="picObj.content" @changeEditor="changeEditor"></editor>-->
      </div>
    </div>

    <div class="tool-drawer-btns">
      <DoubleBtn
        @onClickSave="onClickSave"
        @onClickCancel="clickDelete"
      ></DoubleBtn>
    </div>
    <a-modal
      :title="$t('actionTitles.edit')"
      :visible="editVisible"
      @ok="editVisible = false"
      @cancel="editVisible = false"
      :destroyOnClose="true"
      centered
      width="760px"
    >
      <editor :value="picObj.content" @changeEditor="changeEditor"></editor>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import IconSelect from './IconSelect.vue';
import MaterialSelect from '@/components/MaterialSelect';
import { v4 as uuidv4 } from 'uuid';
import DoubleBtn from '../DoubbleBtn';
import Editor from '@/components/Editor';

export default {
  components: { IconSelect, MaterialSelect, DoubleBtn, Editor },
  props: {
    defaultValue: {
      type: Object,
    },
  },
  data() {
    return {
      btnPosition: [
        { name: '上', align: 'top', edge: 'bottom', x: 0, y: 0 },
        { name: '下', align: 'bottom', edge: 'top', x: 0, y: 0 },
        { name: '左', align: 'left', edge: 'right', x: 0, y: 0 },
        { name: '右', align: 'right', edge: 'left', x: 0, y: 0 },
      ],
      currentPosition: 0,
      selectIcon: '',
      titleStr: '',
      currentImage: {},
      picObj: {
        type: 'pictext',
        hotspot_id: 'hotspot_' + uuidv4(),
        icon_url: '',
        is_dynamic: 0,
        ath: '',
        atv: '',
        title: '',
        is_show_title: 1,
        content: '',
        titleFontSize: 14,
        tit_position_align: 'top',
        tit_position_edge: 'bottom',
        tit_position_x: 0,
        tit_position_y: 0,
        icon_scale: 50,
      },
      editVisible: false,
      currFontSize: 16,
      currScale: 50,
      curr_align: 'top',
      curr_edge: 'bottom',
      curr_x: 0,
      curr_y: 0,
      currTitle: '',
    };
  },
  watch: {
    defaultValue: {
      handler: function (value) {
        if (value) {
          this.picObj = value;
          this.currFontSize = this.picObj.titleFontSize;
          this.currScale = this.picObj.icon_scale;
          this.curr_x = this.picObj.tit_position_x;
          this.curr_y = this.picObj.tit_position_y;
          this.currTitle = this.picObj.title;
          if (this.picObj.tit_position_align == 'top') {
            this.currentPosition = 0;
          } else if (this.picObj.tit_position_align == 'bottom') {
            this.currentPosition = 1;
          } else if (this.picObj.tit_position_align == 'left') {
            this.currentPosition = 2;
          } else if (this.picObj.tit_position_align == 'right') {
            this.currentPosition = 3;
          } else {
            // If tit_position_align is not defined, default to 'top'
            this.currentPosition = 0;
            // this.picObj.tit_position_align = 'top';
          }
        }
      },
      immediate: true,
      deep: true,
    },
    newPicObj: {
      handler: function (val, oldVal) {
        if (val.ath == '' && val.atv == '') {
          const vh = getSceneViewAt();
          this.picObj.ath = vh.hlookat;
          this.picObj.atv = vh.vlookat;
        }
        this.$emit('change', this.picObj, oldVal);
      },
      deep: true,
    },
    currTitle: {
      handler: function (value) {
        const id = this.picObj.hotspot_id;
        setTitle(id, value);
      },
      deep: true,
    },
    currScale: {
      handler: function (value) {
        const id = this.picObj.hotspot_id;
        setIconScale(id, value);
      },
      deep: true,
    },
    currFontSize: {
      handler: function (value) {
        const id = this.picObj.hotspot_id;
        const css = 'css';
        var value =
          'text-align:center; color:#FFFFFF; font-family:MicrosoftYahei; font-size:' +
          value +
          'px';
        setTitlePosition(id, value, css);
      },
      deep: true,
    },
    curr_x: {
      handler: function (value) {
        const id = this.picObj.hotspot_id;
        // const x = 'x';
        // setTitlePosition(id, value, x);

        const axis = 'x';
        // 若左右對立，送反號
        const send = this.isOppositeX(this.curr_align, this.curr_edge)
          ? -value
          : value;
        setTitlePosition(id, send, axis);
      },
      deep: true,
    },
    curr_y: {
      handler: function (value) {
        const id = this.picObj.hotspot_id;
        // const y = 'y'
        // setTitlePosition(id, value, y);

        const axis = 'y';
        // 若上下對立，送反號
        const send = this.isOppositeY(this.curr_align, this.curr_edge)
          ? -value
          : value;
        setTitlePosition(id, send, axis);
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(['vrbase', 'currentScenesId', 'userInfo']),
    newPicObj() {
      return this.$deepClone(this.picObj);
    },
  },
  mounted() {
    // console.log('this.picObj', this.$deepClone(this.vrbase))
    this.$bus.$on('updateHotspot', (e) => {
      if (e.hotspot_id == this.picObj.hotspot_id) {
        this.picObj.ath = e.ath;
        this.picObj.atv = e.atv;
      }
    });
  },
  methods: {
    isOppositeY(align, edge) {
      return align === 'bottom' && edge === 'top';
    },
    isOppositeX(align, edge) {
      return align === 'right' && edge === 'left';
    },
    onClickBtn(item, index) {
      this.currentPosition = index;
      const currId = this.picObj.hotspot_id;

      // 重新把目前的 x/y（滑桿數值）送進 krpano，但在送之前做對立翻號
      const sendX = this.isOppositeX(this.curr_align, this.curr_edge)
        ? -this.curr_x
        : this.curr_x;
      const sendY = this.isOppositeY(this.curr_align, this.curr_edge)
        ? -this.curr_y
        : this.curr_y;

      // 再把調整後的位移送進 krpano
      setTitlePosition(currId, sendX, 'x');
      setTitlePosition(currId, sendY, 'y');

      setHotspotTitlePosition(item, currId);
      this.curr_align = item.align;
      this.curr_edge = item.edge;
      this.curr_x = item.x;
      this.curr_y = item.y;
    },
    onSelectIcon(item) {
      this.picObj.icon_url = item.icon_url;
      this.picObj.is_dynamic = item.is_dynamic;
    },

    isShowTitle(e) {
      this.picObj.is_show_title = e.target.checked ? 1 : 0;
    },

    clickBack() {
      this.$emit('clickBack', this.picObj);
    },
    clickDelete() {
      this.$emit('clickDelete', this.picObj);
    },
    onClickSave() {
      // this.picObj.title = this.titleStr;
      // this.picObj.content = [
      //   { name: this.currentImage.name, img_url: this.currentImage.url },
      // ];
      this.picObj.title = this.currTitle;
      this.picObj.titleFontSize = this.currFontSize;
      this.picObj.icon_scale = this.currScale;
      this.picObj.tit_position_align = this.curr_align;
      this.picObj.tit_position_edge = this.curr_edge;
      this.picObj.tit_position_x = this.curr_x;
      this.picObj.tit_position_y = this.curr_y;
      if (!this.picObj.icon_url) {
        this.$message.error(this.$t('edit.hpInfo.hpIcon'));
        return;
      }
      if (!this.picObj.title) {
        this.$message.error(this.$t('edit.hpInfo.inputTitle'));
        return;
      }
      if (this.picObj.content.length === 0) {
        this.$message.error(this.$t('edit.editMessage.imageAlert'));
        return;
      }
      this.$emit('saveDataToStore', {
        key: this.picObj.hotspot_id,
        data: this.picObj,
      });
    },
    changeEditor(content) {
      this.picObj.content = content;
    },
  },
};
</script>

<style lang="less" scoped>
.image-list {
  padding: 10px 4px;
  text-align: center;
}

.image-list img {
  object-fit: contain;
  width: 200px;
  height: 110px;
}

.material-option {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 10px 20px;
  cursor: pointer;
}

.m-title {
  width: 180px;
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.m-dele {
  width: 30px;
}

.pictext-content {
  display: inline-block;
  width: 100%;
  margin-bottom: 10px;
}
.selectBtn {
  background-color: #7101ad;
  border-color: #7101ad;
}
/deep/ .ql-container {
  height: calc(100% - 66px);
}

.title-input {
  text-align: center;
  width: 50%;
}
.tit-desc-px {
  display: inline-flex;
  align-items: center;
  padding: 5px;
}
.tit-px {
  text-align: right;
}
.title-type {
  width: 80%;
}
.tit_position_bg {
  height: 49px;
  background-color: #212121;
  width: 100%;
  display: flex;
  .positionBtn.tit_active {
    background-color: #7101ad;
    border-color: #7101ad;
  }
  .positionBtn:hover {
    background-color: #d485ff;
    border-color: #d485ff;
  }
}
.tit_position_btn {
  color: #fff;
  background-color: #404040;
  border-color: #2e2e2e;
  margin: 10px 4px;
  border: 1px solid;
  padding: 0 15px;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid #555;
}
.tit_position_btn:hover {
  background-color: #02a2aa;
  border-color: #02a2aa;
  border: 1px solid #fff;
}
.tit_active {
  background-color: #015c61;
  border-color: #015c61;
}
.tit_sliderbar_bg {
  height: auto;
  background-color: #212121;
  width: 100%;
}
.titleScaleBg {
  background-color: #212121;
}
</style>
